const M = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEgM2EyIDIgMCAwIDEgMiAydjE0YTIgMiAwIDAgMS0yIDJIM2EyIDIgMCAwIDEtMi0yVjVhMiAyIDAgMCAxIDItMmgxOHptMCAySDN2MTRoMThWNXptLTQgOXYyaC01di0yaDV6TTYuNiA4LjJsNS4wNjcgMy44TDYuNiAxNS44bC0xLjItMS42TDguMzMzIDEyIDUuNCA5LjhsMS4yLTEuNnoiICBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=";
export {
  M as default
};
//# sourceMappingURL=console-76d1b863.mjs.map
